import React, { useEffect, useRef } from 'react';
import { useWindowWidth } from '../../helpers';
import axios from 'axios';
import { styled } from "../../stitches.config";
import { body, bodyLarge, h1, h2, h4, p } from '../commonStyles/Fonts';

import Contacts from '../components/Career/Contacts';
import Faq from '../components/Career/Faq';
import HowItWorks from '../components/Tip/HowItWorks';
import StepInstruction from '../components/Tip/StepInstruction';
import NumberedList from '../components/Tip/NumberedList';
import TipButton from '../components/Tip/TipButton';
import TipForm from '../components/Tip/TipForm';
import TipAnimation from '../components/Tip/TipAnimation';

import HeroIcon from '../../assets/img/natemat/tip/tip_hero_icon.png';
import { ReactComponent as TipIcon } from '../assets/icons/tip.svg?react';
import { ReactComponent as WartosciIcon } from '../../assets/img/natemat/tip/zgodne_z_wartosciami.svg?react';
import { ReactComponent as OryginalneIcon } from '../../assets/img/natemat/tip/oryginalne_ciekawe_tresci.svg?react';
import { ReactComponent as KreatywnyIcon } from '../../assets/img/natemat/tip/dzial_kreatywny.svg?react';

import image1 from '../../assets/img/natemat/tip/tiphero1.webp';
import image2 from '../../assets/img/natemat/tip/tiphero2.webp';
import image3 from '../../assets/img/natemat/tip/tiphero3.webp';
import tiplistimage from '../../assets/img/natemat/tip/tiplistimage.webp';
import Footer from "../components/Footer"

const AuthorTipPage = () => {

    const isDesktop = useWindowWidth() > 992;

    const SimpleCardsItems = [
        {
            icon: <WartosciIcon />,
            title: 'Zgodne z naszymi wartościami',
            text: 'Treści dostarczane przez zewnętrznych autorów powinny być spójne z naszymi wartościami.'
        },
        {
            icon: <OryginalneIcon />,
            title: 'Oryginalne i ciekawe',
            text: 'Twoje artykuły powinny być związane z tematyką, w której masz doświadczenie i czujesz się ekspertem.'
        },
        {
            icon: <KreatywnyIcon />,
            title: 'Tematyka',
            text: 'Ty nam powiedz, o czym i dlaczego chciałbyś pisać. Nie ograniczamy się do żadnej tematyki.'
        },
    ]

    const faqcontent = [
        {
            title: 'Jak zacząć pisać dla naTemat?',
            text: 'Wypełnij formularz na tej stronie, napisz nam więcej o sobie i o tym, o czym chciałbyś pisać. Nasz zespół odezwie się do wybranych osób. Nie musisz być dziennikarzem, ale musisz mieć coś ciekawego do powiedzenia w swojej działce.',
        },
        {
            title: 'Ile mogę realnie zarobić na napiwkach?',
            text: 'Nie ma żadnych ograniczeń. Wszystko zależy od tego, jak popularne i dobre będą Twoje teksty. Pamiętaj jednak, że napiwki to raczej symboliczne kwoty w ramach podziękowania.',
        },
        {
            title: 'Czy jest szansa, aby z gościnnego autora stać się pełnoprawnym dziennikarzem naTemat?',
            text: 'Projekt "Tip the journalist" jest otwarty na zewnętrznych autorów spoza stałego grona redakcyjnego. W przypadku rekrutacji do newsroomu jako pełnoprawny dziennikarz musisz przejść normalny proces rekrutacji, o którym więcej przeczytasz na kariera.natemat.pl',
        },
        {
            title: 'O czym mogę pisać?',
            text: 'O wszystkim, w czym jesteś ekspertem i masz coś ciekawego do powiedzenia. Nie ograniczamy się do tematyki. Ważne jest, żebyś pasjonował się tym, o czym chcesz pisać i znał się na tej działce.',
        },
        {
            title: 'O czym nie mogę pisać?',
            text: 'Nie ma tematów, o których u nas "nie można pisać". Musi być jedynie ciekawie i zgodnie z misją oraz wartościami Grupy naTemat. Tematy artykułów zgłaszają dziennikarze, a ostateczną decyzją o ich realizacji podejmuje wydawca dnia lub redaktor prowadzący.',
        }
    ]

    const stepItems = [
        {
            title: 'Zgłoszenie',
            description: 'Aplikuj i powiedz nam, o czym chciałbyś pisać i jakie masz doświadczenie w tym temacie.',
        },
        {
            title: 'Założenie konta',
            description: 'Jeśli zostaniesz zaakceptowany, zaloguj się do systemu, gdzie będziesz mógł publikować artykuły.',
        },
        {
            title: 'Publikuj i zarabiaj na napiwkach',
            description: 'Gotowe. Teraz możesz pisać i zarabiać na napiwkach.',
        },

    ]

    const benefitItems = [
        {
            text: 'Promocję najlepszych artykułów na naszej stronie głównej i w social mediach',
        },
        {
            text: 'Twoje bio będzie widoczne pod każdym Twoim artykułem',
        },
        {
            text: 'Możesz budować społeczność wokół swoich tekstów',
        }
    ]

    const tipformref = useRef<HTMLDivElement>(null);


    return (
        <>
            <Container>
                <Hero>
                    <SVGWrapper>
                        <OrangeCircle />
                    </SVGWrapper>
                    <MobileSVG>
                        <WartosciIcon />
                    </MobileSVG>
                    <Content>
                        <img src={HeroIcon} alt="Tip hero logo" />
                        <h1 className={h1()}>Zostań naszym <br /> gościnnym autorem <br /> i zarabiaj na napiwkach</h1>
                        <p className={p()}>Weź udział w naszym nowym projekcie. Pisz artykuły na dowolny temat związany z Twoim doświadczeniem, ale zgodny z naszymi wartościami. Będziesz mógł zarabiać na napiwkach zostawionych przez zadowolonych czytelników. Tu wszystko zależy od Ciebie.</p>
                        <TipButton text='Zacznij dla nas pisać' iconOn={true} elementref={tipformref} id="button1" />
                    </Content>
                    <ImageNet>
                        <div><img src={image1} alt="" style={{ width: '80%' }} /></div>
                        <div>
                            <img src={image2} alt="" style={{ width: '45%' }} />
                            <img src={image3} alt="" style={{ width: '45%' }} />
                        </div>
                    </ImageNet>
                </Hero>
                <TipAnimation />
                <TipBenefits>
                    <BenefitsImage>
                        <img src={tiplistimage} alt="" />
                    </BenefitsImage>
                    <NumberedList items={benefitItems}><h2 className={h2()} style={{ margin: 0 }}>Nie tylko napiwki. <br /> Pisząc dla nas zyskujesz:</h2></NumberedList>
                </TipBenefits>
                <HowItWorks heading='Co i jak pisać, by wziąć udział w projekcie?' items={SimpleCardsItems} />
                <StepInstruction steps={stepItems}>
                    <h1 className={h1()}><OrangeSpan>Trzy proste kroki,</OrangeSpan><br />dzielą Cię od gościnnego<br /> pisania dla naTemat</h1>
                </StepInstruction>
                <Contacts isDesktop={isDesktop}>
                    <ContactContent>
                        <h1 className={h1()}>Twoje teksty będą widoczne obok artykułów naszych dziennikarzy.</h1>
                        <TipButton text='Zacznij dla nas pisać' iconOn={false} elementref={tipformref} id="button2" />
                    </ContactContent>
                </Contacts>
                <TipForm>
                    <TipFormInfo ref={tipformref}>
                        <TipFormInfoHeading>
                            <h2 className={h2()}>Aplikuj do projektu i zacznij zarabiać na napiwkach.</h2>
                            <p className={p()}>Po wysłaniu zgłoszenia, odezwiemy się do Ciebie <br /> i damy znać, czy masz zielone światło. Dowiesz się wtedy, jak dokładnie wygląda proces publikowania.</p>
                        </TipFormInfoHeading>
                    </TipFormInfo>
                </TipForm>
                <Faq header='Więcej o pisaniu dla naTemat jako gościnny autor' items={faqcontent}></Faq>
            </Container>
            <Footer />
        </>
    )
}

export default AuthorTipPage;

const OrangeSpan = styled('span', {
    color: '$natematPrimary',
})

const Container = styled('div', {
    display: 'flex',
    flexDirection: 'column',
})

const Hero = styled('div', {
    position: 'relative',
    backgroundColor: '$grayscale100Fixed',
    display: 'flex',
    flexDirection: 'column',
    padding: '16px',
    paddingBottom: '400px',
    '@bp4': {
        flexDirection: 'row',
        padding: '84px',
        paddingBottom: '141px',
        width: '100%',
    }
})

const SVGWrapper = styled('div', {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    overflow: 'hidden',
})

const MobileSVG = styled('div', {
    dispplay: 'block',
    position: 'absolute',
    right: 0,
    top: 10,
    '@bp4': {
        display: 'none'
    }
})

const OrangeCircle = styled('div', {
    borderRadius: '100%',
    backgroundColor: '$natematPrimary',
    position: 'absolute',
    filter: 'blur(150px)',
    right: '50%',
    transform: 'translate(50%, 0%)',
    bottom: '0%',
    width: '250px',
    height: '250px',
    '@bp4': {
        right: '10%',
        filter: 'blur(350px)',
        top: '50%',
        width: '500px',
        height: '500px',
    }
})

const Content = styled('div', {
    zIndex: 10,
    width: '100%',
    color: '$grayscale0Fixed',
    img: {
        maxWidth: '150px'
    },
    '@bp4': {
        width: '50%',
        img: {
            maxWidth: '250px'
        },
    }
})

const ImageNet = styled('div', {
    width: '100%',
    maxWidth: '400px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    position: 'absolute',
    zIndex: 10,
    bottom: -50,
    right: '50%',
    transform: 'translateX(50%)',
    div: {
        textAlign: 'center',
        img: {
            margin: '4px',
            verticalAlign: 'top',
        }
    },
    '@bp4': {
        width: '50%',
        transform: 'translateX(0%)',
        maxWidth: 'fit-content',
        top: 50,
        right: 0,
        div: {
            textAlign: 'center',
            img: {
                margin: '12px',
                verticalAlign: 'top',
            }
        },
    }
})



const TipBenefits = styled('div', {
    width: '100%',
    padding: '40px 16px ',
    display: 'flex',
    flexDirection: 'column',
    gap: '32px',
    justifyContent: 'center',
    alignItems: 'center',
    '@bp4': {
        padding: '168px 108px ',
        gap: '108px',
        flexDirection: 'row',
    }
})

const BenefitsImage = styled('div', {
    width: '100%',
    maxWidth: '450px',
    background: '$natematPrimary',
    img: {
        width: '100%',
        height: '100%',
    },
    '@bp4': {
        maxWidth: '516px',
        width: '50%',
    }
})

const TipFormInfo = styled('div', {
    display: 'flex',
    width: '100%',
    maxWidth: '350px',
    flexDirection: 'column',
    gap: '48px',
    '@bp4': {
        width: '450px',
    }
})

const TipFormInfoHeading = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
})

const TipFormInfoContent = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    div: {
        color: '$grayscale75',
    },
    h4: {
        color: '$grayscale0Fixed',
        margin: 0,
    }
})

const ContactContent = styled('div', {
    width: '100%',
    '@bp4': {
        width: '450px',
    }
})